import { BaseModel } from '@shared/base/Base.Model';
import { IWebSocketModel } from '@shared/interface/IWebSocketModel';
import { WebSocketModelUtility } from '@shared/utility/WebSocketModel.Utility';

export interface IConnectionRequestModel {
    token: string;
    secureToken: string;
}

export class ConnectionRequestModel extends BaseModel implements IConnectionRequestModel, IWebSocketModel {
    public static readonly expectedPacketType: string = 'connect';

    public isIWebSocketModel: boolean = true;
    public packetType: string = 'connect';
    public id: number = null;

    public token: string = null;
    public secureToken: string = null;

    public constructor() {
        super();
    }

    public loadFromWebSocketMessage(message: any): void {
        WebSocketModelUtility.loadProperties(message, this, 'RIFT-WS-ConnectionRequestModel');
    }

    public toWebSocketMessage(): any {
        return {
            ...WebSocketModelUtility.toJson(this),
        };
    }
}
